import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Modal, Popover, QuillText } from '@treams/treams-ui';

export default function CycleMomentInstructionModal(props: {
	title: string;
	instruction?: graphql.LocalizedAttributedString;
	buttonTitle: string;
	onCancel: () => void;
	onStart: () => void;
}) {
	const { localize } = useLocalize();

	return (
		<Popover center visible onDismiss={props.onCancel}>
			<Box onClick={(event) => event.stopPropagation()}>
				<Modal>
					<Modal.Header onClose={() => props.onCancel()} title={props.title} />
					<Modal.Contents>
						<QuillText value={localize(props.instruction ?? [])?.text} />
					</Modal.Contents>

					<Modal.FormFooter
						saveTitle={props.buttonTitle}
						onSave={props.onStart}
						onCancel={props.onCancel}
					/>
				</Modal>
			</Box>
		</Popover>
	);
}
